import { useContext, useState } from "react";
import { OverlapInfo } from "../../models/OverlapInfo";
import { EditorContext } from "../EditorCommon/EditorContext";

export function DoorOverlapSetter(props: Exclude<React.HTMLProps<HTMLSelectElement>, { value: any, onChange: any }>) {
    const ec = useContext(EditorContext);


    const [str, setStr] = useState(ec.cabinet.numDoorOverlaps?.toString());

    async function setDoorOverlaps(evt: React.ChangeEvent<HTMLSelectElement>) {
        const newValStr = evt.target.value;
        const newVal = parseInt(newValStr);
        const result = await ec.cabinetService.setNumOverlaps(newVal);
        if (!result.success)
            return;

        setStr(newValStr);
    }

    const overlapInfos = ec.cabinetService.getOverlapInfos();
    function optionTranslator(oi: OverlapInfo) {
        return ec.translator("doorEditor selector numOverlaps", "{overlaps} Overlap", { overlaps: oi.numOverlaps.toString() });
    }
    const options = overlapInfos
        .map(oi => <option value={oi.numOverlaps} key={oi.numOverlaps}>{optionTranslator(oi)}</option>);

    return (
        <select {...props}
            value={str}
            onChange={setDoorOverlaps}
        >
            {options}
        </select>

    );

}
